import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(list)/internal-orders',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/orders/internal-orders' ||
      location.pathname === '/orders/internal-orders/'
    ) {
      throw redirect({
        to: '/orders/internal-orders/active',
        search: { aiSummaryId: undefined, aiOrderNumber: undefined },
      });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/InternalOrdersLayout'),
    'InternalOrdersLayout',
  ),
});
